<template>
  <div style="height: 100%"></div>
</template>

<script>
import * as echarts from 'echarts';
import { mapGetters } from 'vuex'
export default {
  name: "pieChart",
  props: {chartData: Object},
  data() {
    return {
      chart: null,
      resizeHandler: null
    }
  },
  computed: {
    ...mapGetters([
      'isCollapse'
    ])
  },
  watch: {
    isCollapse() {
      this.resizeChart();
    },
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      }
    }
  },
  methods: {
    resizeChart() {
      this.chart.resize();
    },
    initChart() {
      this.chart = echarts.init(this.$el);
      this.setOptions(this.chartData);
    },
    setOptions({title, roseType, radius, data} = {}) {
      this.chart.clear();
      this.chart.setOption({
        title: {
          text: title
        },
        tooltip: {
          trigger: 'item',
        },
        legend: {
          bottom: "bottom",
          // orient: 'vertical',
          type: "scroll"
        },
        series: [
          {
            type: 'pie',
            roseType: roseType,
            radius: radius,
            center: ['50%', '50%'],
            data: data,
            animationEasing: 'cubicInOut',
            animationDuration: 3000
          }
        ]
      })
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
      this.resizeHandler = () => {
        this.resizeChart();
      };
      window.addEventListener("resize", this.resizeHandler);
    })
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
    }
    window.removeEventListener("resize", this.resizeHandler);
  }
}
</script>

<style scoped>

</style>
